import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { PopupAction } from '../../../common/popup/PopupAction'
import { keyBy } from '../../../helpers/common'
import { isInValidValue } from '../../../helpers/value'
import classes from '../../index.module.scss'
import '../../lang/i18n'
import { POPUP_FIELDS_KEYS, SELECT_FIELD } from '../constants'
import { InputUserProfile } from '../form/InputUserProfile'
import { checkEmailValid, checkInvalidInputVal } from '../helper'
import {
  selectCountriesList,
  selectListFieldRequest,
  setListFieldRequest,
} from '../store/slice'
import {
  getCountries,
  getUserProfileFields,
  postUpdateUserProfileRequest,
} from '../store/thunk'
import { CountriesSelection } from './CountriesSelection'
import { DeleteAddButtons } from './DeleteAddButton'
import { FieldSelection } from './FieldSelection'
import { SelectIndustry } from './SelectIndustry'

const MAX_LENGTH_REQUEST = 5

export const ContentPopupRequest = ({
  isOpen,
  onClose,
  userProfile,
  setIsOpenPopupRequest,
  vsics,
}) => {
  const dispatch = useDispatch()

  const listFieldRequest = useSelector(selectListFieldRequest)
  const countriesList = useSelector(selectCountriesList)

  const defaultCountry =
    countriesList?.find((item) => item.id === userProfile?.companyLocationId) ||
    {}

  const defaultIndustry =
    vsics?.find((item) => item.id === userProfile?.companyVSICId) || {}

  const [isValid, setIsValid] = useState({
    [POPUP_FIELDS_KEYS.EMAIL]: true,
    [POPUP_FIELDS_KEYS.COMPANY_NAME]: true,
    [POPUP_FIELDS_KEYS.TAX_CODE]: true,
    [POPUP_FIELDS_KEYS.COUNTRY]: true,
    [POPUP_FIELDS_KEYS.INDUSTRY]: true,
    [POPUP_FIELDS_KEYS.NONE]: true,
  })
  const [country, setCountry] = useState(defaultCountry)
  const [industry, setIndustry] = useState(defaultIndustry)

  const onChange = (index, event, key) => {
    const eventValue = event.target.value

    if (!!eventValue.trim()) {
      setIsValid({
        ...isValid,
        [key]: true,
      })
    }

    if (key === POPUP_FIELDS_KEYS.EMAIL) {
      if (!!eventValue.trim()) {
        setIsValid({
          ...isValid,
          [key]: checkEmailValid(eventValue),
        })
      } else {
        setIsValid({
          ...isValid,
          [key]: true,
        })
      }
    }

    const newListFieldRequest = listFieldRequest.map((obj, ind) => {
      if (index === ind) {
        return {
          ...obj,
          inputValue: eventValue || '',
        }
      }

      return obj
    })
    dispatch(setListFieldRequest(newListFieldRequest))
  }

  const editRequest = listFieldRequest
    ?.filter((item) => !checkInvalidInputVal(item.inputValue))
    .map((item) => ({
      fieldCode: item.value,
      newValue: item.inputValue,
    }))

  const dataKeyListRequest = keyBy(listFieldRequest, 'fieldCode')

  const onSubmit = () => {
    setIsValid({
      [POPUP_FIELDS_KEYS.EMAIL]: dataKeyListRequest[POPUP_FIELDS_KEYS.EMAIL]
        ? checkEmailValid(
            dataKeyListRequest[POPUP_FIELDS_KEYS.EMAIL]?.inputValue,
          )
        : true,
      [POPUP_FIELDS_KEYS.COMPANY_NAME]: dataKeyListRequest[
        POPUP_FIELDS_KEYS.COMPANY_NAME
      ]
        ? dataKeyListRequest[POPUP_FIELDS_KEYS.COMPANY_NAME]?.inputValue
        : true,
      [POPUP_FIELDS_KEYS.TAX_CODE]: dataKeyListRequest[
        POPUP_FIELDS_KEYS.TAX_CODE
      ]
        ? dataKeyListRequest[POPUP_FIELDS_KEYS.TAX_CODE]?.inputValue
        : true,
      [POPUP_FIELDS_KEYS.COUNTRY]: dataKeyListRequest[POPUP_FIELDS_KEYS.COUNTRY]
        ? !!country?.value
        : true,
      [POPUP_FIELDS_KEYS.INDUSTRY]: dataKeyListRequest[
        POPUP_FIELDS_KEYS.INDUSTRY
      ]
        ? !!industry?.value
        : true,
      [POPUP_FIELDS_KEYS.NONE]: dataKeyListRequest[POPUP_FIELDS_KEYS.NONE]
        ? false
        : true,
    })

    if (Object.values(isValid).includes(false)) {
      return
    }
    const isContainBlankValue = listFieldRequest.some(
      (item) => !item.inputValue,
    )

    if (editRequest.length && !isContainBlankValue) {
      dispatch(
        postUpdateUserProfileRequest({
          updateUserProfileRequestModel: { fields: editRequest },
        }),
      )
      setIsOpenPopupRequest(false)
    }
  }

  useEffect(() => {
    dispatch(getCountries({}))
    dispatch(getUserProfileFields({}))

    return () => {
      dispatch(
        setListFieldRequest([
          {
            label: SELECT_FIELD.label,
            value: 'none',
            inputValue: '',
            isI18n: true,
            fieldCode: 'none',
          },
        ]),
      )
    }
  }, [])

  useEffect(() => {
    if (country) {
      const newListFieldRequest = listFieldRequest.map((obj) => {
        if (obj.fieldCode === POPUP_FIELDS_KEYS.COUNTRY) {
          return { ...obj, inputValue: country?.id }
        }
        return obj
      })
      dispatch(setListFieldRequest(newListFieldRequest))
    }
  }, [country])

  const getTextInvalid = (key, value) => {
    let textInvalid = 'userProfile.REQUIRED_FIELD'

    if (key === POPUP_FIELDS_KEYS.EMAIL) {
      textInvalid = !value
        ? 'userManagement.valid.email'
        : 'cartAndOrders.message.m01'
    }
    if (key === POPUP_FIELDS_KEYS.COMPANY_NAME) {
      textInvalid = 'userManagement.valid.companyName'
    }
    if (key === POPUP_FIELDS_KEYS.TAX_CODE) {
      textInvalid = 'userManagement.valid.taxCode'
    }
    if (key === POPUP_FIELDS_KEYS.NONE) {
      textInvalid = 'userManagement.valid.none'
    }

    return textInvalid
  }

  return (
    <>
      <PopupAction
        title="userProfile.EDIT_PROFILE"
        isShow={isOpen}
        handleClose={onClose}
        btnSubmit={{
          label: 'userProfile.SEND_REQUEST',
          event: onSubmit,
          isI18n: true,
          style: { fontSize: 12 },
        }}
        appendStyle={{
          width: 560,
          padding: '20px 20px 8px 20px',
          backgroundColor: '#F3F3F3',
          borderRadius: '4px',
        }}
      >
        <Element className={classes.popUpText}>
          <Translate value="userProfile.POPUP_REQUEST_TITLE" />
        </Element>
        {listFieldRequest.map((item, index) => (
          <div className="dFlex justifyContentBetween" key={index}>
            <div className={classes.popUpFieldSelection}>
              <FieldSelection
                item={item}
                index={index}
                listFieldRequest={listFieldRequest}
                userProfile={userProfile}
              />
              {item.value === POPUP_FIELDS_KEYS.COUNTRY ? (
                <CountriesSelection
                  activeCountry={country}
                  setCountry={setCountry}
                  countriesList={countriesList}
                  isValid={isValid[POPUP_FIELDS_KEYS.COUNTRY]}
                  setIsValid={setIsValid}
                />
              ) : item.value === 'CompanyVSICId' ? (
                <SelectIndustry
                  vsics={vsics}
                  activeIndustry={industry}
                  setIndustry={setIndustry}
                  listFieldRequest={listFieldRequest}
                  isValid={isValid[POPUP_FIELDS_KEYS.INDUSTRY]}
                  setIsValid={setIsValid}
                />
              ) : (
                <InputUserProfile
                  containerStyle={{
                    height: 28,
                    marginLeft: 5,
                    marginTop: -30,
                    width: 280,
                    marginBottom:
                      item.value === POPUP_FIELDS_KEYS.NONE &&
                      !isValid[POPUP_FIELDS_KEYS.NONE]
                        ? 30
                        : 0,
                  }}
                  value={item.inputValue || ''}
                  isShowLabel={isInValidValue(item.inputValue)}
                  onChange={(e) => onChange(index, e, item.value)}
                  isValid={!item.value ? true : !!isValid[item.value]}
                  textInvalid={getTextInvalid(item?.value, item?.inputValue)}
                  disabled={item.value === POPUP_FIELDS_KEYS.NONE}
                  styleTextInvalid={{
                    bottom: item.value === POPUP_FIELDS_KEYS.NONE ? -30 : -15,
                  }}
                />
              )}
            </div>
            <>
              <DeleteAddButtons
                showDeleteBtn={listFieldRequest.length > 1}
                showAddBtn={listFieldRequest.length < MAX_LENGTH_REQUEST}
                index={index}
                dataKeyListRequest={dataKeyListRequest}
                setIsValid={setIsValid}
                isValid={isValid}
                keyItem={item?.value}
              />
            </>
          </div>
        ))}
      </PopupAction>
    </>
  )
}
